<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-if="formParam.id!='' && formParam.id!=null">Edit Account</h5>
          <h5 class="modal-title" v-else-if="formParam.copy==true">Copy Account</h5>
          <h5 class="modal-title" v-else>Add Account</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">Content Publishing</h4>
                  <div class="statistics">
                    <p
                      class="text-muted"
                    >You can use the Instagram Graph API to publish single images, videos, reels (i.e. single media posts), or posts containing multiple images and videos (carousel posts) on Instagram Business accounts.</p>
                    <h4 class="card-title">Limitations</h4>
                    <ul class="text-muted">
                      <li>Instagram Creator accounts are not supported.</li>
                      <li>Accounts are limited to 25 API-published posts within a 24 hour period. Carousels count as a single post.</li>
                      <li>JPEG is the only image format supported.</li>
                      <li>Stories are not supported.</li>
                      <li>Shopping tags are not supported.</li>
                      <li>Publishing to Instagram TV is not supported.</li>
                    </ul>
                    <div class="text-center">
                      <router-link
                        ref="dismisModal"
                        data-dismiss="modal"
                        to="/instagram/accounts/official/add/content_publishing"
                      >
                        <i class="la la-user"></i> Add Account
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">Full Access</h4>
                  <div class="statistics">
                    <p
                      class="text-muted"
                    >Allows Instagram Professionals — Businesses and Creators — to manage its presence on Instagram, find hashtagged media, and get basic metadata and metrics about other Instagram Businesses and Creators.</p>
                    <h4 class="card-title">Before You Start</h4>
                    <span class="text-muted">You will need access to the following:</span>
                    <ul>
                      <li>
                        An
                        <a
                          href="https://help.instagram.com/502981923235522?fbclid=IwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE"
                          target="_blank"
                          rel="noopener nofollow"
                          data-lynx-mode="asynclazy"
                          data-lynx-uri="https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F502981923235522%3Ffbclid%3DIwAR0QyyjxqL0PT8WxFogNeNakz1xuvKYmGh53QeqT3IhNhAx3enUUPPL47TE&amp;h=AT3wxMg8_QOoZLOWSDy5Y5ytcMUQDoH_bRCycjha8Pd7dcKMgDHqwvmi1rMquN0a6bgYH1C3wStngFfzQwCcQqS13wv5iFZlvTO-uWVPmUcyXXj4_1VdHdGYmBZtSSHVEqPMuMNdJEY"
                        >Instagram Business Account</a> or
                        <a
                          href="https://help.instagram.com/1158274571010880?fbclid=IwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs"
                          target="_blank"
                          rel="noopener nofollow"
                          data-lynx-mode="asynclazy"
                          data-lynx-uri="https://l.facebook.com/l.php?u=https%3A%2F%2Fhelp.instagram.com%2F1158274571010880%3Ffbclid%3DIwAR0iKSP5MVPR5-3oxn3N3iNuLf4I3TVEEf8MnumHa4uUsedlxMzCB-MHIZs&amp;h=AT0T1h-Cl5r2zGniRgPnUvf61PcucFdUDWxcCx63nhpI38PJZy0rXKiDx1TcSd4s28ZbVOJ94cjLzskJ6JGABKf8xC1BZiWsxno_yj9DnW8kgFap59iCBmSK8mIGverB4BnK0LQLWx0"
                        >Instagram Creator Account</a>
                      </li>
                      <li>
                        A
                        <a
                          target="_blank"
                          href="https://developers.facebook.com/docs/instagram-api/overview#pages"
                        >Facebook Page connected to that account</a>
                      </li>
                    </ul>
                    <div class="text-center">
                      <router-link
                        ref="dismisModal"
                        data-dismiss="modal"
                        to="/instagram/accounts/official/add/full_access"
                      >
                        <i class="la la-user"></i> Add Account
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      isSending: false,
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      formParam: {
        copy: false,
        brand_id: [],
        ig: {
          id: "",
          username: "",
          password: ""
        }
      },
      isLoading: false
    };
  },
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        // if (val != oldVal) {
        if (val.length > 0) {
          this.formParam.brand_id = [];
          this.selectedContact.forEach((row, idx) => {
            this.formParam.brand_id.push(row.id);
          });
          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedContact = [];
          this.formParam.brand_id = [];
          return;
        }
      },
      deep: true
    },

    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            console.log("that.formParamSt", that.formParamSt);
            if (
              that.formParamSt.ig.id != "" &&
              that.formParamSt.ig.id != null
            ) {
              if (
                typeof that.formParam.copy != "undefined" &&
                that.formParam.copy == true
              ) {
                that.formParam.id = "";
                that.formParam.ig.id = "";
              }

              that.formParam = that.formParamSt;
              that.formParam.ig.password = "";
              console.log("that.formParamxx", that.formParam);
              that.selectedContact = that.formParam.brand_selected;
              that.contactOptions = that.formParam.brand_selected;
              // that.asyncFindSelect("", that.formParam.brand_id);
            } else {
              console.log("else");

              that.asyncFind("");
              that.formParam = {
                brand_id: [],
                ig: {
                  id: "",
                  username: "",
                  password: ""
                },
                brand_selected: []
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamSt() {
      return this.$store.state.instagramAccount.formParamSt;
    },
    isShowForm() {
      return this.$store.state.instagramAccount.isShowForm;
    }
  },
  methods: {
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = "";
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;

          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    asyncFindSelect(query, id) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = id;

      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          if (id != "") {
            if (this.contactOptions.length > 0) {
              this.selectedContact = this.contactOptions[0];
            }
          }
          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          let action = "create";
          if (this.formParam.ig.id != "") {
            action = "update";
          }

          await this.$store
            .dispatch("instagramAccount/" + action, this.formParam)
            .then(response => {
              // this.isSending = false;
              if (this.formParam.ig.id == "") {
                this.selectedContact = [];
                this.contactOptions = [];
                this.formParam = {
                  brand_id: [],
                  ig: {
                    id: "",
                    username: "",
                    password: ""
                  },
                  brand_selected: []
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                this.selectedContact = [];
                this.contactOptions = [];
                var elem = this.$refs.dismisModal;
                elem.click();
                this.formParam = {
                  brand_id: [],
                  ig: {
                    id: "",
                    username: "",
                    password: ""
                  },
                  brand_selected: []
                };
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramAccount/formOfficial.vue